




























































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';
import { validationMixin } from 'vuelidate'
import { required, requiredIf, minLength, sameAs } from 'vuelidate/lib/validators'

import { getFieldError } from '@/core/tools/forms/get_field_error';

import { STORE_KEY as PARENT_STORE_KEY } from '../_store';
import { STORE_KEY, store } from './_store';

@Component({
  mixins: [ validationMixin ],
  computed: {
    // ...mapState(PARENT_STORE_KEY, [
    //   'document'
    // ]),
    ...mapState(STORE_KEY, [
      'loaded', 'loading', 'fatalError',
      'reserves'
      // 'form', 'formDirty',
    ]),
    // ...mapGetters(STORE_KEY, [
    //   'reserves'
    // ])
  },
  methods: {
    getFieldError,
    ...mapActions(STORE_KEY, [
      'addItem', 'removeItem'
    ])
  },
  validations() {
    const rules: any = {
      // name: { required, minLength: minLength(3) },
      // status_id: { required },

      // client_id: { required },
      // delivery_point_id: {},
      // expected_delivery_date: {},

      // manager_id: {},
      // payment_type_id: {},
      // counterparty_id: {},
      // delivery_warehouse_id: {},
    }

    return {
      form: rules
    }
  }
})
export default class DeliveryInventoryForm extends Vue {

  @Prop() zone!: any
  reserves!: any[];

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    console.log('mounted', this.zone)

    if (this.zone.id) {
      this.$store.dispatch(`${STORE_KEY}/init`, {
        zone: this.zone
      });
    } else {
      console.log('error')
    }
  }

  changeValue(index: number, field: string, value: any) {
    this.$store.dispatch(`${STORE_KEY}/changeFormValue`, {
      index, field, newValue: value
    });

    // @ts-ignore
    // this.$v.form[field].$touch();
    // this.$v.form.$touch();
  }

  saveFormData() {
    // this.$v.form.$touch()

    // if(!this.$v.form.$error) {
      this.$store.dispatch(`${STORE_KEY}/saveForm`)
      .then((result) => {
        this.$buefy.snackbar.open(`Данные успешно сохранены`);
        // this.$v.form.$reset();
        console.log('123123')
        this.$store.dispatch(`${PARENT_STORE_KEY}/updateReserves`, {
          zone: this.zone,
          reserves: this.reserves
        });

        // this.$emit('on-need-data-reload', result.document.id)
      })
      .catch(() => {
        this.$buefy.snackbar.open({
          type: 'is-warning',
          message: `При сохранении возникли проблемы. Попробуйте позже.`
        })
      })
    // }

  }

  beforeDestroy() {
    this.$store.dispatch(`${STORE_KEY}/reset`);
    // this.$store.unregisterModule(STORE_KEY);
  }
}
